import { useAuth } from "../hooks";
import { useCurrentTalentProfile } from "../hooks";
import UserRoutes from "./UserRoutes";
import TalentRoutes from "./TalentRoutes";
import GuestRoutes from "./GuestRoutes";
import useCurrentBusinessInfo from "../hooks/useCurrentBusiness";

export default function AppRouter() {
  const { userInfo, accessToken } = useAuth();
  const { currentProfile } = useCurrentTalentProfile();
  const { currentBusiness } = useCurrentBusinessInfo();
  // Check if user is authenticated
  const isAuthenticated = !!accessToken && !!userInfo;

  // If not authenticated, show guest routes
  if (!isAuthenticated) {
    return <GuestRoutes />;
  }

  // If authenticated, show appropriate routes based on user type
  if (currentProfile || currentBusiness) {
    return <TalentRoutes />;
  } else {
    return <UserRoutes />;
  }
}
